import * as React from 'react';
import { PdsIconBellNotification as PdsIconBellNotificationElement } from '@principal/design-system-icons-web';
import {
  IconSize,
  ValidIconColor,
} from '../../../utils/icon-utilities';
import { createPdsReactComponent } from '../../../../../react/src/lib/create-pds-react-component';

interface IconProps {
  size?: IconSize;
  color?: ValidIconColor;
}

export const PdsIconBellNotification = createPdsReactComponent<IconProps>()({
  tagName: 'pds-icon-bell-notification',
  elementClass: PdsIconBellNotificationElement,
  react: React,
});
